<template>
    <hr class="divider-segment">
</template>

<script>
    export default {
        props: {
            id: String,
            segmentData: Object,
            displayOnly: Boolean,
        },
    }
</script>

<style lang="scss">
    .divider-segment {
        border-color: #313131;
        margin: 40px 0;
    }
</style>